import { Injectable, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';

@Injectable(    {
    providedIn: 'root',
})
export class TemplatePageTitleStrategy extends TitleStrategy {
    private readonly title = inject(Title);


    override updateTitle(routerState: RouterStateSnapshot) {
        const title = this.buildTitle(routerState);
        if (title !== undefined) {
            this.title.setTitle(`${title} | Lidoma Gaming Platform`);
        }
    }
}
